import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout, NotApprovedNotice } from '../../components/AuthLayout.js';
import { NOT_APPROVED, readApiError } from '../../lib/apiError.js';

export default function RegisterPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [pendingEmail, setPendingEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setPendingEmail('');

    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 2000);
      } else {
        const err = await readApiError(res, 'Registration failed');
        if (err.code === NOT_APPROVED) setPendingEmail(email.trim());
        else setError(err.message);
      }
    } catch (err: unknown) {
      console.error(err);
      setError('Network error');
    }
  };

  return (
    <AuthLayout
      title="Request access"
      subtitle="Velinko is invite-only. Use the email you want approved; once it is, this form creates your account."
    >
      {error && <div className="auth-error">{error}</div>}
      {pendingEmail && <NotApprovedNotice email={pendingEmail} />}
      {success && <div className="auth-success">Account created. Taking you to sign in…</div>}
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
          <span className="hint">At least 8 characters.</span>
        </div>
        <button type="submit" className="btn btn-primary">
          Request access
        </button>
      </form>

      <div className="auth-links">
        <Link to="/login">Already approved? Sign in</Link>
        <Link to="/docs#getting-started">How it works</Link>
      </div>
    </AuthLayout>
  );
}
